import { ossUrl } from '../config/base'
import uuid from 'uuid/v1'

export default {
  methods: {
    isImage (filename) {
      return ['jpeg', 'jpg', 'png'].indexOf(_.last(filename.split('.'))) > -1
    },
    getOssPath (filename) {
      return [ossUrl, 'files', filename].join('/')
    },
    showPreview (files) {
      this.$store.commit('assignValue', {
        previewFiles: []
      })
      this.$store.commit('assignValue', {
        previewFiles: files
      })
    },
    download (data) {
      let blob = new Blob([data])
      let downloadElement = document.createElement('a')
      let href = window.URL.createObjectURL(blob)

      downloadElement.href = href
      downloadElement.download = `${uuid()}.xlsx`
      document.body.appendChild(downloadElement);

      downloadElement.click();

      document.body.removeChild(downloadElement);
      window.URL.revokeObjectURL(href);
    }
  }
}
